import { YANDEX_METRIKA_ID } from '../const';

type TrackEventParams = {
    eventAction: string;
    eventCategory?: string;
    eventLabel?: string;
    userSessionTime?: string;
    promptText?: string;
};

declare global {
    interface Window {
      ym?: (...args: any[]) => void;
    }
}

const trackEvent = (eventType: string, params: TrackEventParams): void => {
    const eventData = { eventType, ...params };

    if (window.ym) {
        window.ym(YANDEX_METRIKA_ID, 'reachGoal', params.eventAction, eventData);
    }
};

const trackPublish = (): void => {
    trackEvent("click", { eventAction: "publish_avatar_button_click", eventCategory: "Links", eventLabel: "Publish Avatar Button"});
};

const trackUserTimeInApp = (time: string): void => {
    trackEvent("timing", {
        eventAction: "user_time_in_app",
        eventCategory: "User Engagement",
        userSessionTime: time,
    });
};

const trackCopyLink = (): void => {
    trackEvent("click", { eventAction: "copy_avatar_link_button_click", eventCategory: "Links" });
};

const trackPrompt = (promptText: string): void => {
    trackEvent("view", { eventAction: "avatar_prompt", eventCategory: "User Input", promptText });
};

export { trackPublish, trackCopyLink, trackPrompt, trackUserTimeInApp };
